"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CloseButton = props => {
  const {
    background,
    onClose,
    size,
    ...rest
  } = props;
  let variant = '';
  if (background === 'light' && size === 'default') {
    variant = 'mm-close-button';
  }
  if (background === 'light' && size === 'sm') {
    variant = 'mm-close-button-sm';
  }
  if (background === 'dark' && size === 'default') {
    variant = 'mm-close-button--reverse';
  }
  if (background === 'dark' && size === 'sm') {
    variant = 'mm-close-button--sm-reverse';
  }
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    type: "button",
    className: variant,
    "aria-label": "Close",
    onClick: onClose
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "X"));
};
var _default = exports.default = CloseButton;
CloseButton.propTypes = {
  /**
   * Background color that the button will appear on.  The button does not contain a background color itself.
   */
  background: _propTypes.default.oneOf(['light', 'dark']),
  /**
   * An optional callback method to add functionality for when the close button is closed.
   */
  onClose: _propTypes.default.func,
  /**
   * The size of the close button
   */
  size: _propTypes.default.oneOf(['default', 'sm'])
};
CloseButton.defaultProps = {
  size: 'default',
  background: 'light'
};